import { Redirect, Route, RouteChildrenProps, RouteProps } from 'react-router'

import { useSession } from '@signavio/effektif-api'
import { ComponentType } from 'react'

interface PublicRouteProps extends Omit<RouteProps, 'component'> {
  component: ComponentType<React.PropsWithChildren<RouteChildrenProps>>
}

function PublicRoute({
  component: Component,

  ...rest
}: PublicRouteProps) {
  const session = useSession()

  return (
    <Route
      {...rest}
      render={(props) => {
        if (session.sessionState === 'loggedIn') {
          const currentOrg = session.organization.key

          return <Redirect to={`/${currentOrg}/cases/tasks`} />
        }

        return <Component {...props} />
      }}
    />
  )
}

export default PublicRoute
